import { render, staticRenderFns } from "./QuestionStorageList.vue?vue&type=template&id=0ea47976&"
import script from "./QuestionStorageList.vue?vue&type=script&lang=js&"
export * from "./QuestionStorageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports